import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './TopNavBar.css';

const TopNavBar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleDealsClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      // Already on landing page, just scroll to hot deals
      const hotDealsSection = document.getElementById('hot-deals');
      if (hotDealsSection) {
        hotDealsSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to landing page and then scroll to hot deals
      navigate('/');
      setTimeout(() => {
        const hotDealsSection = document.getElementById('hot-deals');
        if (hotDealsSection) {
          hotDealsSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <nav className="top-navbar">
      <div className="navbar-container">
        {/* Logo Section */}
        <div className="nav-logo">
          <a href="/" className="logo-link">
            <img 
              src="/img/logo-full.svg" 
              alt="Fish Finder Tools" 
              className="logo logo-desktop"
            />
            <img 
              src="/img/logo-icon.svg" 
              alt="Fish Finder Tools" 
              className="logo logo-mobile"
            />
          </a>
        </div>

        {/* Navigation Links */}
        <div className="nav-links">
          <div className="nav-dropdown">
            <button 
              className="dropdown-toggle"
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              Tools ▼
            </button>
            {isDropdownOpen && (
              <div 
                className="dropdown-menu"
                onMouseEnter={() => setIsDropdownOpen(true)}
                onMouseLeave={() => setIsDropdownOpen(false)}
              >
                <a href="/custom-builder" className="dropdown-item">
                  LiveScope Builder
                </a>
                <a href="/compare-screens" className="dropdown-item">
                  Screen Comparison
                </a>
                <a href="/price-comparison" className="dropdown-item">
                  Price Comparison
                </a>
                <a href="/select/battery" className="dropdown-item">
                  Battery Guide
                </a>
                <a href="/blackfriday2025deals" className="dropdown-item">
                  Black Friday 2025 Deals
                </a>
              </div>
            )}
          </div>
          <span className="nav-divider">|</span>
          <a href="/#hot-deals" className="nav-link" onClick={handleDealsClick}>
            Today's Deals
          </a>
        </div>
      </div>
    </nav>
  );
};

export default TopNavBar; 